import { config, normalizeConfiguredDomain } from '../../config';
import { ApiError } from '../../lib/api';

export function platformEmailDomain(): string {
  return normalizeConfiguredDomain(config.platformPrimaryDomain);
}

export function isEmailAllowedForPlatformDomain(email: string, domain: string): boolean {
  const normalizedDomain = normalizeConfiguredDomain(domain);
  if (!normalizedDomain) return false;
  const at = email.trim().toLowerCase().lastIndexOf('@');
  if (at <= 0 || at === email.trim().length - 1) return false;
  return email.trim().toLowerCase().slice(at + 1) === normalizedDomain;
}

export type PasswordResetChannel = 'email' | 'sms';

async function authFetch(path: string, body: unknown): Promise<void> {
  const res = await fetch(config.apiBase + path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Client-Id': config.clientId,
      'X-Client-Key': config.clientKey,
    },
    body: JSON.stringify(body),
  });
  const payload = (await res.json().catch(() => ({}))) as {
    error?: { code?: string; message?: string };
  };
  if (!res.ok) {
    throw new ApiError(
      res.status,
      payload.error?.code ?? `HTTP_${res.status}`,
      payload.error?.message ?? `HTTP ${res.status}`,
      res.headers.get('X-Request-Id')
    );
  }
}

export async function requestPasswordReset(email: string, channel: PasswordResetChannel = 'email'): Promise<void> {
  await authFetch('/v3/auth/forgot-password', { email, region: config.region, channel });
}

export async function resetPassword(token: string, newPassword: string): Promise<void> {
  await authFetch('/v3/auth/reset-password', { token, new_password: newPassword });
}
